import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Configurator } from '../../home/models/configurator';
import { ViewerService } from '../link-service.service';
import { IIShapesPasswordDialogComponent } from '../password-dialog/password-dialog.component';

@Component({
  selector: 'iishapes-viewer',
  templateUrl: './viewer.component.html',
  styleUrls: ['./viewer.component.sass'],
})
export class ViewerComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('viewerElement', { static: false }) set viewerElementSetter(ref: ElementRef<any>) {
    if (ref) {
      this.viewerElement = ref;
      console.log('viewerElement ahora está disponible', ref.nativeElement);
    }
  }
  viewerElement: ElementRef<any>;

  public configurator = new Configurator();
  public isViewerReady = false;
  public showViewer = true;
  public password: string = '';
  public viewer_id: string = '';
  public ip: string = '';
  private waitForViewerMethods(cb: () => void, tries: number = 20) {
    const el = this.viewerElement.nativeElement;
    if (!el) return;
    if (
      typeof el.setMaterialByName === 'function' &&
      typeof el.updateViewerOption === 'function'
    ) {
      cb();
    } else if (tries > 0) {
      setTimeout(() => this.waitForViewerMethods(cb, tries - 1), 50);
    } else {
      console.warn('Viewer methods not available after waiting!');
    }
  }

  constructor(
    public router: Router, private route: ActivatedRoute,
    private viewerService: ViewerService, public dialog: MatDialog,
    public deviceDetectorService: DeviceDetectorService

  ) {

    this.viewerService.getIPAddress().subscribe(ip => {
      console.log('IP Address:', ip);
      this.ip = ip;

    });



  }


  ngOnInit(): void {

    console.log('Initializing ViewerComponent');
    this.deviceDetectorService.isMobile();
    this.route.params.subscribe(params => {
      const id = params['id'];
      this.viewer_id = id;

      this.viewerService.getViewerDesignRequiresPassword(id).subscribe(
        requiresPassword => {
          if (requiresPassword == false) {
            this.loadConfigurator();
          } else {
            this.passwordDialog();
          }
        },
        error => {
          console.error('Error loading configurator:', error);
          // Manejar el error, por ejemplo, redirigir a página de error o mostrar mensaje
          this.router.navigate(['/forbidden']);
        }
      );
    });
  }




  ngAfterViewInit(): void {
    this.viewerElement.nativeElement.addEventListener('ready', () => {
      this.waitForViewerMethods(() => {
        this.isViewerReady = true;
      });
    });
  }


  passwordDialog() {
    const dialogRef = this.dialog.open(IIShapesPasswordDialogComponent, {
      width: '500px',
      panelClass: 'custom-dialog-container',
      data: {
        designViewerId: this.viewer_id
      }
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result === undefined) {
        this.router.navigate(['/forbidden']);

      } else {

        console.log('Dialog closed with result:', result);
        this.password = result;
        this.loadConfigurator();
      }


      // this.sceneManagerService.setTryon(this.design.options.tryon);
    });
  }

  loadConfigurator() {

    this.viewerService.getViewerDesign(this.viewer_id, this.ip, this.password)
      .subscribe(
        res => {
          this.configurator = res;
          this.configurator.options_render.model.url = this.configurator.ready_file;
          const toViewerParams = this.configurator.options_render.toViewParameters() || {};

          this.viewerElement.nativeElement.setObjectSelectionEnabled(false);
          this.viewerElement.nativeElement.setModelOptions(toViewerParams);
        },
        error => {
          console.error('Error loading configurator:', error);
          // Manejar el error, por ejemplo, redirigir a página de error o mostrar mensaje
          this.router.navigate(['/forbidden']);
        }
      );
  }



  ngOnDestroy() {
    this.showViewer = false;
    if (this.viewerElement?.nativeElement) {
      if (typeof this.viewerElement.nativeElement.dispose === 'function') {
        this.viewerElement.nativeElement.dispose();
      }
      // Quita el elemento del DOM (extra seguridad)
      if (this.viewerElement.nativeElement.parentNode) {
        this.viewerElement.nativeElement.parentNode.removeChild(this.viewerElement.nativeElement);
      }
    }
  }
}
